// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__q7V_a","header":"ReportDetails_header__Sxn94","title":"ReportDetails_title__3Y7yq","left":"ReportDetails_left__1-t7L"};